module.exports = __webpack_public_path__ + "img/92.f46c1c5a.png";